module.exports = __webpack_public_path__ + "img/nellie.3aada016.jpg";